import React, { useEffect, useState } from "react";
import { Col, Form, InputGroup, Row } from "react-bootstrap";
import purchaceprofile from "../../assets/images/purchaceprofile.svg";
import Email from "../../assets/images/email.svg";
import call from "../../assets/images/call.svg";
import boxcount from "../../assets/images/boxcount.svg";
import downloadAction from "../../assets/images/download.svg";
import downloadAction2 from "../../assets/images/download2.svg";
import { useDispatch, useSelector } from "react-redux";
import { MachinePurchaseList } from "../../services/ReduxTookit/Slice/MachineRedux";
import annualsummary from "../../assets/images/My_machine.svg";
import DemoLogo from "../../assets/images/quantummain.svg";
import { commonservices } from "../../services/CommonServices";
import Nodata from "../../component/common-component/Nodata";
import { Link, useNavigate } from "react-router-dom";
import Loader, { LoaderType } from "../../component/common-component/Loader";
import Skeleton from "react-loading-skeleton";
import stars from "../../assets/images/stars.svg";
import searchicon from "../../assets/images/searchicon.svg";
import useDebounce from "../../hooks/useDebounce";
import InvoiceModel from "../../component/Workflow/FlowNewModels/InvoiceModel";
import { InvoiceDownload } from "../../services/ReduxTookit/Slice/InvoiceRedux";

const PurchaseManagementModel = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(true);
  const [searchTerm, setSearchTerm] = useState("");
  const debouncingValue = useDebounce(searchTerm, 500);
  const [invoiceModel, setInvoiceModel] = useState(false);
  const [invoiceLoading, setInvoiceLoading] = useState(false);
  const MyPurchaseList = useSelector(
    (state) =>
      state?.machineredux?.MachinePurchaseListData?.data?.data?.data?.dataList1
  );

  const getMachineList = () => {
    setLoading(true);
    let body = {
      machineName: debouncingValue,
    };
    dispatch(MachinePurchaseList(body))?.then((res) => {
      setLoading(false);
    });
  };

  const getInvoicePdf = async (invoiceNo) => {
    setInvoiceLoading(true);
    try {
      const body = { invoiceNo };
      const response = await dispatch(InvoiceDownload(body));

      const fileUrl = response?.payload?.data?.data; // Ensure it's a valid URL
      if (!fileUrl) {
        throw new Error("File URL not found");
      }

      // Open in a new tab to prevent opening in the same window
      window.open(fileUrl, "_blank");
    } catch (error) {
      console.error("Error downloading invoice:", error);
    }
    setInvoiceLoading(false);
  };

  useEffect(() => {
    getMachineList();
  }, [debouncingValue]);
  return (
    <>
      <div className="header-search-input searchplaceholder purchaseSearch">
        <InputGroup>
          <InputGroup.Text id="basic-addon1">
            <img src={searchicon} alt="searchicon" className="cursor-pointer" />
          </InputGroup.Text>
          <Form.Control
            placeholder="Search Purchases"
            aria-label="Search"
            aria-describedby="basic-addon1"
            value={searchTerm}
            onChange={(e) => {
              setSearchTerm(e.target.value);
            }}
          />
        </InputGroup>
      </div>
      <div className="purchases-profile-main">
        {!loading && MyPurchaseList?.length > 0 ? (
          MyPurchaseList?.map((item, index) => {
            return (
              <div className="profile-common" key={index}>
                <Row className="align-items-center">
                  <Col sm={4}>
                    <div className="profile-purchases-inner d-flex gap-3 align-items-center">
                      <div className="profile-purchases-pic">
                        <img
                          src={
                            item?.machinelogo !== "" &&
                            item?.machinelogo !== null
                              ? item?.machinelogo
                              : DemoLogo
                          }
                          width={"25px"}
                          height={"25px"}
                          alt={item?.machinename}
                          onError={({ currentTarget }) => {
                            currentTarget.onerror = null;
                            currentTarget.src = DemoLogo;
                          }}
                        />
                      </div>
                      <div>
                        <div className="purchase-listing-show d-flex cursor-pointer">
                          <h4
                            className="cursor-pointer"
                            onClick={() =>
                              navigate(
                                `/marketplace/marketplace-detail/${commonservices.bodyEncryption(
                                  String(item?.machineid)
                                )}/Marketplace`
                              )
                            }
                            title={item?.machinename}
                          >
                            {/* {commonservices.truncateText(item?.machinename, 15)} */}
                            {item?.machinename}
                          </h4>
                          {/* {item?.avgrating > 0 && ( */}
                          <div className="market-place-content-ratings ms-2">
                            <img src={stars} alt="stars" />
                            <span>{item?.avgrating?.toFixed(1) || 0}</span>
                          </div>
                          {/* )} */}
                        </div>

                        <div
                          className="grey-btn purchase-content"
                          style={{ padding: "5px 5px" }}
                        >
                          {item?.categoryname}
                        </div>
                      </div>
                      {/* <div> rewiew </div> */}
                    </div>
                  </Col>
                  <Col sm={4}>
                    <div className="Development-detail-price">
                      <Link
                        to="/marketplace/developer"
                        className="theme-color-text"
                        state={{
                          subscriberId: item.developersubscriberid,
                        }}
                      >
                        <h3>
                          {item?.subscribername ? item?.subscribername : "-"}
                        </h3>
                      </Link>
                      <a
                        className="d-flex align-items-center gap-2 mt-1 "
                        href={`mailto:${item?.email}`}
                      >
                        <span>
                          {" "}
                          <img src={Email} alt="Email" />
                        </span>
                        <span>{item?.email && item?.email}</span>
                      </a>
                      <a
                        className="d-flex align-items-center gap-2 mt-1 "
                        // href={item?.contactno}
                      >
                        <span>
                          {" "}
                          <img src={call} alt="call" />
                        </span>
                        <span>{item?.contactno && item?.contactno}</span>
                      </a>
                    </div>
                  </Col>
                  <Col sm={1}>
                    <div className="countdata">
                      <div className=" d-flex align-items-center gap-1">
                        <img src={boxcount} alt="boxcount" />
                        <h3>{item?.workflowusecount}</h3>
                      </div>
                    </div>
                  </Col>
                  <Col sm={2}>
                    <div className="dateprice">
                      <h3>
                        {parseInt(item?.price) === 0
                          ? "Free"
                          : `$  ${item?.price}`}
                      </h3>
                      <p>
                        {item?.lastupdatedon
                          ? commonservices.getDateInFormatCustom(
                              item?.lastupdatedon,
                              null,
                              "MMMM DD,YYYY"
                            )
                          : ""}
                      </p>
                    </div>
                  </Col>
                  <Col sm={1}>
                    <div className="purchasedown d-flex justify-content-end cursor-pointer">
                      <img
                        src={downloadAction2}
                        alt="downloadAction2"
                        // onClick={() => setInvoiceModel(true)}
                        onClick={() => {
                          getInvoicePdf(item?.invoiceno);
                        }}
                      />
                    </div>
                  </Col>
                </Row>
              </div>
            );
          })
        ) : (
          <>
            {loading ? (
              <Loader type={LoaderType.SupportSetting} count={5} />
            ) : (
              <Nodata />
            )}
          </>
        )}
      </div>
      {invoiceModel && (
        <InvoiceModel
          show={invoiceModel}
          onHide={() => setInvoiceModel(false)}
        />
      )}
    </>
  );
};

export default PurchaseManagementModel;
